<template>
  <div>
    <div class="container mb-10">
      <div id="title-div">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-sm-1">
              <button type="button" class="btn btn-primary" @click="back()">
                Back
              </button>
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-8 text-center">
              <h3 class="card-title align-items-center flex-column">
                <span class="card-label page-title fw-bolder fs-3 mb-1">
                  {{ name }}</span
                >
              </h3>
            </div>
            <div class="col-sm-2 align-self-end text-right">
              <button
                type="button"
                class="btn btn-primary"
                @click="addSubscriberModal = true"
              >
                Add Subscriber
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="spacer-y-10"></div>

      <div>
        <input
          type="text"
          class="form-control form-control-lg form-control-solid px-15"
          v-model="search"
          placeholder="Search"
          data-kt-search-element="input"
        />
      </div>
      <v-data-table
        :headers="tableHeaders"
        :items="subscribers"
        item-key="email"
        class="elevation-1"
        :loading="loading"
        loading-text="Loading Subscribers..."
        :page.sync="currentPage"
        @page-count="pageCount = $event"
        :sort-by="sort.by"
        :sort-desc="sort.desc"
      >
        <template v-slot:[`item.type`]="{ item }">
          {{ getSubscriberType(item) }}
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <a @click="deleteSubscriber(item)">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
                stroke="#060606"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M14 8L8 14"
                stroke="#060606"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M8 8L14 14"
                stroke="#060606"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path></svg
          ></a>
        </template>
      </v-data-table>
    </div>
    <AddSubscriber
      v-model="addSubscriberModal"
      :workers="workers"
      :subscribers="subscribers"
      @close="addSubscriberModal = false"
      @addSubscriber="addSubscriber"
    />
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="confirmationAccept"
      @eCancel="confirmationReject"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import mixins from "vue-typed-mixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import AddSubscriber from "@/components/AddSubscriber.vue";

export default mixins(ConfirmationModalMixin, SnackbarNotifierMixin).extend({
  name: "ViewEmail",
  components: {
    SnackbarNotifier,
    ConfirmationModal,
    AddSubscriber,
  },
  data() {
    return {
      loading: false,
      addSubscriberModal: false,
      emailId: "",
      name: "",
      subscribers: [],
      search: "",
      limit: 1000,
      pullLimit: 1000,
      startKey: null,
      pageCount: 0,
      currentPage: 1,
      sort: {
        by: ["name"],
        desc: [false],
      },
      tableHeaders: [
        { text: "Email", value: "emailAddress" },
        { text: "Type", value: "type" },
        { text: "", value: "action" },
      ],
      workers: [],
      limit: 1000,
    };
  },
  methods: {
    back() {
      this.$router.push({ name: "Admin", hash: "#manageNotificationEmails" });
    },
    getSubscriberType(item) {
      if (item.isBackendUserAccount) {
        return "Worker Account";
      }
      return "Email Address";
    },
    async deleteSubscriber(item) {
      try {
        const shouldDeleteSubscriber = await this.confirm();
        this.stopConfirmationLoading();
        if (!shouldDeleteSubscriber) {
          return;
        }
        this.loading = true;

        await ApiService.Instance.removeEmailSubscriber({
          emailId: this.emailId,
          subscriberAddress: item.emailAddress,
        });

        this.showNotifier({
          message: `Removed Subscriber`,
          snackbarType: "success",
        });

        await this.getEmail();
      } catch (e) {
        error(e);
        this.showNotifier({
          message: `Failed To Remove Subscriber`,
          snackbarType: "error",
        });
      }
      this.loading = false;
    },
    async addSubscriber(payload) {
      try {
        this.addSubscriberModal = false;
        const shouldAddSubscriber = await this.confirm();
        this.stopConfirmationLoading();
        if (!shouldAddSubscriber) {
          return;
        }
        this.loading = true;

        const input = {
          emailId: this.emailId,
          emailAddress: payload.email,
          name: payload.name,
        };

        if (payload.type == "worker") {
          input.name = `${payload.firstName} ${payload.lastName}`;
          input.adminId = payload.id;
        }

        await ApiService.Instance.addEmailSubscriber(input);

        this.showNotifier({
          message: `Added Subscriber`,
          snackbarType: "success",
        });

        await this.getEmail();
      } catch (e) {
        error(e);
        this.showNotifier({
          message: `Failed To Add Subscriber`,
          snackbarType: "error",
        });
      }
    },
    async getEmail() {
      try {
        this.loading = true;

        const result = await ApiService.Instance.getEmail({
          id: this.emailId,
        });

        this.name = result.name;
        this.subscribers = result.subscribers;
      } catch (e) {
        error(e);
      }
      this.loading = false;
    },
    async getAdminList() {
      try {
        let startKey = undefined;
        do {
          const result = await ApiService.Instance.getAllWorkers({
            headers: {
              startKey,
              limit: this.limit,
            },
          });

          if (!!result.data) {
            this.workers.push(...result.data);
          }

          startKey = result.lastEvaluatedKey;
        } while (!!this.startKey);
      } catch (e) {
        error(e);
      }
    },
  },
  async beforeMount() {
    try {
      this.emailId = this.$route.params.emailId;
      await this.getEmail();
      await this.getAdminList();
    } catch (e) {
      error(e);
    }
  },
});
</script>

<style lang="scss" scoped>
</style>